import { FormattedMessage } from "react-intl";
import Tabs from "../../Shared/Tabs/Tabs";
import styles from "./EditUser.module.css";

enum TabKeys {
  GeneralDetails = "general_details",
  Security = "security",
}

type EditUserProps = {
  isUserSelected?: boolean;
  detailsTabContent?: JSX.Element;
  securityTabContent?: JSX.Element;
};

const EditUser = ({
  isUserSelected,
  detailsTabContent,
  securityTabContent,
}: EditUserProps) => {
  const tabs = [
    // General details
    {
      id: TabKeys.GeneralDetails,
      title: (
        <FormattedMessage
          id="MANAGEMENT.USER_DETAILS.GENERAL_DETAILS"
          defaultMessage="General Details"
        />
      ),
      body: detailsTabContent,
      bodyClassName: `${styles.content} h-100`,
    },
    // Security
    {
      id: TabKeys.Security,
      title: (
        <FormattedMessage
          id="MANAGEMENT.USER_DETAILS.SECURITY"
          defaultMessage="Security"
        />
      ),
      body: securityTabContent,
      bodyClassName: `${styles.content} h-100`,
    },
  ];

  return !isUserSelected ? (
    <NoSelectedUserPlaceholder />
  ) : (
    <Tabs
      defaultActiveKey={TabKeys.GeneralDetails}
      tabs={tabs}
      navBarClassName={styles.tabsNav}
      contentClassName="h-100"
    />
  );
};
export default EditUser;

const NoSelectedUserPlaceholder = () => (
  <div className="d-flex flex-column h-100">
    <div className={styles.emptyHeader}></div>
    <div className={`${styles.emptyBody} flex-grow-1 p-3 font-md muted-color`}>
      <FormattedMessage
        id="MANAGEMENT.USER_DETAILS.EMPTY"
        defaultMessage="User details will show here"
      />
    </div>
  </div>
);
